import { Deletable, Identificable } from 'shared/types/commonView';
import { DocumentTypes } from 'shared/types/document';
import { UploadStatus } from 'shared/types/uploadStatus';

export enum ImageRotation {
  ROTATE_0 = 0,
  ROTATE_90 = 90,
  ROTATE_180 = 180,
  ROTATE_270 = 270,
}

export type DocumentOutDto = {
  title: string;
  type: 'FILE' | string;
  description: string;
  imageRotation: ImageRotation;
  name: string;
  fileType: string;
  extension: string;
  bucketName: string;
  documentType: DocumentTypes;
  key: string;
  thumbnailKey: string;
  url: string;
  drawings?: Array<{
    _id: string;
    drawnUploadStatus?: UploadStatus;
    mergedUploadStatus?: UploadStatus;
  }>;
} & Identificable &
  Deletable;

type DocumentDrawingOutDto = NonNullable<DocumentOutDto['drawings']>[number];


type DocumentPatchDrawing = Partial<
  Omit<DocumentDrawingOutDto, 'drawnUploadStatus' | 'mergedUploadStatus'>
> & {
  drawnUploadStatus?: UploadStatus;
  mergedUploadStatus?: UploadStatus;
};

export type DocumentPatchOutDto = Partial<
  Pick<DocumentOutDto, 'fileType' | 'description' | 'imageRotation'>
> & {
  isDrawn?: boolean;
  drawings?: DocumentPatchDrawing[];
};

export type DocumentUpdatePayload = {
  description?: string;
  imageRotation?: ImageRotation;
  'data.isDrawn'?: boolean;
  'data.type'?: string;
  'data.drawnUploadStatus'?: UploadStatus;
  'data.mergedUploadStatus'?: UploadStatus;
  'data.drawingSrc'?: string;
  'data.mergedSrc'?: string;
  'data.thumbnailMergedSrc'?: string;
};
